export const trackUtil = (loggerPayload) => {
  if (!(loggerPayload && loggerPayload)) return;

  let analyticsData = {};
  let data = loggerPayload;

  analyticsData.prop0 = 'b2b|enterprise|dedicated internet';
  // prop1 is for abValue
  // prop2 not set yet

  if (data && data.eVar0) analyticsData.eVar0 = data.eVar0;
  if (data && data.eVar8) analyticsData.eVar8 = data.eVar8;
  if (data && data.eVar9) analyticsData.eVar9 = data.eVar9;
  if (data && data.prop16) analyticsData.prop16 = data.prop16;
  if (data && data.prop19) analyticsData.prop19 = data.prop19;
  if (data && data.prop20) analyticsData.prop20 = data.prop20;
  if (data && data.prop35) analyticsData.prop35 = data.prop35;
  if (data && data.prop17) analyticsData.prop17 = data.prop17;
  if (data && data.prop15) analyticsData.prop15 = data.prop15;
  if (data && data.prop14) analyticsData.prop14 = data.prop14;
  if (data && data.prop18) analyticsData.prop18 = data.prop18;
  if (data && data.prop22) analyticsData.prop22 = data.prop22;
  if (data && data.prop23) analyticsData.prop23 = data.prop23;
  if (data && data.prop21) analyticsData.prop21 = data.prop21;
  if (data && data.prop36) analyticsData.prop36 = data.prop36;
  if (data && data.prop28) analyticsData.prop28 = data.prop28;
  if (data && data.prop41) analyticsData.prop41 = data.prop41;
  if (data && data.prop49) analyticsData.prop49 = data.prop49;

  if (typeof ClickStream !== 'undefined') window.ClickStream.trackEvent(analyticsData);
};
